export default __webpack_public_path__ + "static/media/1175.4c1bb2ef.png";